// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"vw_a bhc_b"};